const { default: axios } = require("axios");
import { createApp } from 'vue';
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
// import 'swiper/css/pagination';

var gap = document.getElementById("gap").clientWidth;
var gap2x = document.getElementById("gap-2x").clientWidth;
var mVert = document.getElementById("m-vert").clientWidth;
var mVertSlim = document.getElementById("m-vert-slim").clientWidth;
var widthMargin = document.getElementById("width-margin").clientWidth;
var articleWidth = document.getElementById("article-width").clientWidth;

window.addEventListener('load',function() {

    if (document.getElementById("app")) {
        createApp({
            delimiters: ['${', '}'],
            data() {
                return {
                    waitForApi: false,
                }
            },
        }).mount('#app');
    }

    // Event-Slider (Startseite)
    document.querySelectorAll('.wp-block-ff-event-slider').forEach(function (block) {
        new Swiper(block.querySelector('.swiper'), {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            breakpoints: {
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3.1 },
                1280: { slidesPerView: 4 },
            },
            navigation: {
                prevEl: block.querySelector('.swiper-button-prev'),
                nextEl: block.querySelector('.swiper-button-next'),
            },
        });
    });

    // Sponsoren: Swiper nur unterhalb 1024px, darüber statische Leiste
    var sponsorEl = document.querySelector('#sponsors .swiper');
    if (sponsorEl) {
        var sponsorSwiper = null;
        var mq = window.matchMedia('(min-width: 1024px)');

        var handleSponsors = function () {
            if (mq.matches) {
                if (sponsorSwiper) {
                    sponsorSwiper.destroy(true, true);
                    sponsorSwiper = null;
                }
            } else if (!sponsorSwiper) {
                sponsorSwiper = new Swiper(sponsorEl, {
                    modules: [Autoplay],
                    slidesPerView: 2.2,
                    spaceBetween: gap2x,
                    centeredSlides: true,
                    loop: true,
                    speed: 5000,
                    autoplay: {
                        delay: 0,
                    },
                    breakpoints: {
                        640: { slidesPerView: 2.5 },
                        768: { slidesPerView: 4 },
                    },
                });
            }
        };

        handleSponsors();
        mq.addEventListener('change', handleSponsors);
    }

    // Lightbox: Galerien gruppieren, Raumplan hat data-fancybox bereits im Markup
    document.querySelectorAll('.wp-block-gallery figure > a').forEach(function (a) {
        a.setAttribute('data-fancybox', 'gallery');
    });
    if (window.jQuery && jQuery.fn.fancybox) {
        jQuery('[data-fancybox]').fancybox({
            buttons: ['zoom', 'close'],
        });
    }

    // Mobile-Menü
    var trigger = document.getElementById("trigger");
    if (trigger) {
        trigger.addEventListener("click", function () {
            if (trigger.classList.contains("open")) {
                trigger.classList.remove("open");
                document.querySelector("body").classList.remove("scroll-lock");
                document.getElementById("mobile_menu").classList.remove("open");
            } else {
                trigger.classList.add("open");
                document.querySelector("body").classList.add("scroll-lock");
                document.getElementById("mobile_menu").classList.add("open");
            }
        });
    }

})
